export function onMaskPhoneNumber(value: string) {
  const onlyDigits = value.replace(/\D/g, '');

  let maskedValue = '+7';

  const { length } = onlyDigits;
  if (length > 1) {
    maskedValue += ` (${onlyDigits.slice(1, 4)}`;
  }
  if (length > 4) {
    maskedValue += `) ${onlyDigits.slice(4, 7)}`;
  }
  if (length >= 7) {
    maskedValue += ` ${onlyDigits.slice(7, 9)}`;
  }
  if (length >= 9) {
    maskedValue += ` ${onlyDigits.slice(9, 11)}`;
  }

  return maskedValue.trim();
}
